import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import React from 'react';
import { Container } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import AppComponent from './components/app/app-component';
import WalletComponent from './components/wallet/wallet-component';
import CollectionsComponent from './components/collections/collections-component';
import MainMenuComponent from './components/main-menu/main-menu-component';
import PageNotFoundComponent from './components/page-not-found/page-not-found-components';
import OrbDetailsComponent from './components/orb-details/orb-details-component';
import Footer from './components/footer/footer';
import TransactionsComponent from './components/transactions/transactions-component';
import CollectionDetailsComponent from './components/collection-details/collection-details-component';
import 'react-toastify/dist/ReactToastify.css';

export default function AppRouter(): JSX.Element {
  return (
    <Router>
      <Container>
        <MainMenuComponent />
        <ToastContainer />
        <Routes>
          <Route path="/" element={<AppComponent />} />
          <Route path="/collections" element={<CollectionsComponent />} />
          <Route path="/collection" element={<CollectionDetailsComponent />} />
          <Route path="/transactions" element={<TransactionsComponent />} />
          <Route path="/transactions/:txId" element={<TransactionsComponent />} />
          <Route path="/address" element={<WalletComponent />} />
          <Route path="/orb/:orbId" element={<OrbDetailsComponent />} />
          <Route path="/collection/:collectionName" element={<CollectionDetailsComponent />} />
          <Route path="/wallet/:selectedAddress" element={<WalletComponent />} />
          <Route path="*" element={<PageNotFoundComponent />} />
        </Routes>
      </Container>
      <Footer />
    </Router>
  );
}
